export default "__VITE_ASSET__C5p6Kbg8__"